export default __webpack_public_path__ + "static/media/logo-white.89a64dc0.png";